module.exports = __webpack_public_path__ + "static/media/playstation.41022207.svg";